// extracted by mini-css-extract-plugin
module.exports = {"root":"Formats_root___yLJ0"};